const config = {
    //DESARROLLO
    //API_URL: 'http://localhost:3000/api-profit',
    //PRUEBAS
    //API_URL: 'http://18.234.239.145:443/api-profit',
    //PRODUCCIÓN
    API_URL: 'https://www.sistemaprofit.com/api-profit',

};

export default config;
